import { AddressForm, ContactDataIndividual, ContactDataOrganization } from './model/occupied_contract_partner.model';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { InvoiceAddressForm } from './model/empty_contract_partner.model';

export function buildPrivateIndividualFormWithDefaultValues(formBuilder: FormBuilder) {
  return buildPrivateIndividualForm(formBuilder, null);
}

export function buildPrivateIndividualForm(formBuilder: FormBuilder, privateIndividualContactData: ContactDataIndividual | null) {
  return formBuilder.group({
    firstName: [privateIndividualContactData?.firstName ?? '', [Validators.required, CustomValidators.firstNameValidator]],
    lastName: [privateIndividualContactData?.lastName ?? '', [Validators.required, CustomValidators.lastNameValidator]],
    email: [privateIndividualContactData?.email ?? '', [Validators.required, CustomValidators.emailValidator]],
    phoneNumber: [privateIndividualContactData?.phoneNumber ?? '', CustomValidators.optionalPhoneNumberValidator],
  });
}

export function buildOrganizationFormWithDefaultValues(formBuilder: FormBuilder) {
  return buildOrganizationForm(formBuilder, null);
}

export function buildOrganizationForm(formBuilder: FormBuilder, organizationContactData: ContactDataOrganization | null) {
  return formBuilder.group({
    name: [organizationContactData?.name ?? '', CustomValidators.companyNameValidator],
    firmenbuchNr: [organizationContactData?.firmenbuchNr ?? '', CustomValidators.optionalFirmenbuchNrValidator],
    email: [organizationContactData?.email ?? '', [Validators.required, CustomValidators.emailValidator]],
    phoneNumber: [organizationContactData?.phoneNumber ?? '', CustomValidators.optionalPhoneNumberValidator],
    uid: [organizationContactData?.uid ?? '', CustomValidators.uidValidator],
  });
}

export function buildInvoiceAddressFormWithDefaultValues(formBuilder: FormBuilder) {
  return buildInvoiceAddressForm(formBuilder, null);
}

export function buildInvoiceAddressForm(formBuilder: FormBuilder, invoiceAddress: InvoiceAddressForm | null) {
  return formBuilder.group({
    company: [invoiceAddress?.company ?? '', CustomValidators.companyNameValidator],
    address: buildAddressForm(formBuilder, invoiceAddress?.address),
  });
}

export function buildAddressFormWithDefaultValues(formBuilder: FormBuilder) {
  return buildAddressForm(formBuilder, null);
}

export function buildAddressForm(formBuilder: FormBuilder, address: AddressForm | null) {
  return formBuilder.group({
    plz: [address?.plz ?? '', [Validators.required, CustomValidators.plzValidator]],
    city: [address?.city ?? '', [Validators.required, CustomValidators.cityValidator]],
    street: [address?.street ?? '', [Validators.required, CustomValidators.streetValidator]],
    houseNumberStaircase: [address?.houseNumberStaircase ?? '', [Validators.required, CustomValidators.houseNumberStaircaseValidator]],
    door: [address?.door ?? '', [CustomValidators.doorNumberValidator]],
  });
}
